
import { defineComponent } from "vue";
const BASE_PAGE_LAYOUT = "prev, pager, next";
const HIGH_PAGE_COUNT_LAYOUT = "prev, pager, next, jumper";
export default defineComponent({
  name: "Pagination",
  props: {
    currentPage: {
      type: Number
    },
    totalPages: {
      type: Number
    },
    maxPages: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
      selectedPage: this.currentPage || 1
    };
  },
  computed: {
    pagerLayout() {
      if (!this.totalPages) {
        return BASE_PAGE_LAYOUT;
      }
      return this.totalPages > 20 ? HIGH_PAGE_COUNT_LAYOUT : BASE_PAGE_LAYOUT;
    }
  },
  methods: {
    changeCurrentPage(pageNumber) {
      this.selectedPage = pageNumber;
      this.$emit("changeCurrentPage", this.selectedPage);
    }
  }
});
